<script>
import Layout from "../../layouts/main";
import NewsApi from "@/services/news-api";

export default {
  name: "Catalogue",

  props: {
    
  },

  components: {
    Layout
  },

  data() {
    return {
      blogDetails: null,
      htmlData: null,
      allBlog : null,
      
      localSeoName: null,


    }
  },

  mounted() {
    if(this.seoName){
      this.localSeoName = this.seoName 
      this.getBlogBySeoName();
    }
  },

  watch:{

    '$route': {
            immediate: true,
            deep: true, 
            handler(route) {
              this.localSeoName  = route.params.name;
              
              this.getBlogBySeoName();
            }
        },

  },

  methods: {
 
    getBlogBySeoName() {
      NewsApi.getBlogBySeoName(this.localSeoName)
        .then(result => {

          this.allBlog = result;
          this.blogDetails = result.find(blog => blog.position === 1);
          this.previousBlog = result.find(blog => blog.position === 0);
          this.nextBlog = result.find(blog => blog.position === 2);


        })
        .catch(error => {
          console.error("Error fetching blog details:", error);
        });
    }
  }
};
</script>

<template>
  <Layout>
    <div v-if="blogDetails" class="row mt-4">
        <div class="col-12 mt-4" style="display: contents;">
            <div class="col-1 d-none d-lg-flex"/>
            <div class="col-12 col-lg-10 p-1 p-sm-2 p-md-4 p-lg-4" style="overflow: hidden;">
                <div class=" text-left text-secondary font-size-16"  > {{blogDetails.tags}}</div>
                <h1 class=" text-left text-dark font-weight-bold  mb-2" style="font-size: 28px; margin: 0;" > {{ blogDetails.name }}</h1>

                <span class="mb-2">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"  class="mb-1 mr-2 ">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM9.75 8.25V5.25C9.75 4.83579 9.41421 4.5 9 4.5C8.58579 4.5 8.25 4.83579 8.25 5.25V9C8.25 9.41421 8.58579 9.75 9 9.75H11.625C12.0392 9.75 12.375 9.41421 12.375 9C12.375 8.58579 12.0392 8.25 11.625 8.25H9.75Z" fill="#3E3E59"/>
                
                </svg>
                <span  class="mr-4  font-size-16">{{ blogDetails.dateStr }} </span>

                  <span v-if="blogDetails.countComments  && blogDetails.countComments > 0">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-1 mr-2 " >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25 4.5C4.85218 4.5 4.47064 4.65804 4.18934 4.93934C3.90804 5.22064 3.75 5.60218 3.75 6V10.5C3.75 10.8978 3.90804 11.2794 4.18934 11.5607C4.47064 11.842 4.85217 12 5.25 12H6.75C6.94891 12 7.13968 12.079 7.28033 12.2197L9 13.9393L10.7197 12.2197C10.8603 12.079 11.0511 12 11.25 12H12.75C13.1478 12 13.5294 11.842 13.8107 11.5607C14.092 11.2794 14.25 10.8978 14.25 10.5V6C14.25 5.60217 14.092 5.22064 13.8107 4.93934C13.5294 4.65804 13.1478 4.5 12.75 4.5H5.25ZM3.12868 3.87868C3.69129 3.31607 4.45435 3 5.25 3H12.75C13.5456 3 14.3087 3.31607 14.8713 3.87868C15.4339 4.44129 15.75 5.20435 15.75 6V10.5C15.75 11.2956 15.4339 12.0587 14.8713 12.6213C14.3087 13.1839 13.5456 13.5 12.75 13.5H11.5607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303L6.43934 13.5H5.25C4.45435 13.5 3.69129 13.1839 3.12868 12.6213C2.56607 12.0587 2.25 11.2956 2.25 10.5V6C2.25 5.20435 2.56607 4.44129 3.12868 3.87868ZM5.25 6.75C5.25 6.33579 5.58579 6 6 6H12C12.4142 6 12.75 6.33579 12.75 6.75C12.75 7.16421 12.4142 7.5 12 7.5H6C5.58579 7.5 5.25 7.16421 5.25 6.75ZM6 9C5.58579 9 5.25 9.33579 5.25 9.75C5.25 10.1642 5.58579 10.5 6 10.5H10.5C10.9142 10.5 11.25 10.1642 11.25 9.75C11.25 9.33579 10.9142 9 10.5 9H6Z" fill="#3E3E59"/>
                    </svg>
                    <span class=" font-size-16" >{{ blogDetails.countComments }} </span>
                    <span class=" font-size-16" > Commentaires </span>
                  </span>
                </span>

                <div  v-html="blogDetails.description" class="mt-4 mb-5"></div>

                <div style="border-top: 1px solid rgba(234, 234, 234, 1) ; margin-top:70px ; margin-bottom: 50px;"  /> 

                <div class="row mt-4" >
                  <div class="col-12  mt-4" style="display: contents;">

                    <div  class="col-12 col-lg-6 text-left">
                      <span v-if="blogDetails.tags" class="font-size-16 text-dark font-weight-bold pr-2"> Tags: </span>
                      <span class="font-size-16 text-secondary"> {{blogDetails.tags}} </span>
                    </div> 

                    <div class="col-12 col-lg-6 text-left mt-2 mt-lg-0 text-lg-right">
                      <span class="font-size-16 text-dark font-weight-bold pr-3 text-dark"> Partager: </span>
                      <a href="https://www.facebook.com/HAMADIABID.2016" target="_blank"><img class="mb-2" src="@/assets/icons/facebook.svg"  ></a> 
                      <a href="https://www.instagram.com/ha.hamadiabid/" target="_blank"><img class="mb-2 pl-3" src="@/assets/icons/instagram.svg"  ></a>
                      <a href="mailto:Service.client@ha.com.tn"><img class="mb-2 pl-3" src="@/assets/icons/email.svg"></a>
                    </div> 

                  </div>
                </div>

                <div class="row mt-5" >
                  <div class="col-12  " style="display: contents;">
                    <div class="col-6 text-left">
                      
                      <div style="cursor: pointer;" v-if="this.previousBlog">
                        <a :href="'/actualites/' + encodeURIComponent(previousBlog.seoName)">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-1">
                            <path d="M5 12H19" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 12L11 18" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 12L11 6" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="font-size-18 text-dark  font-weight-bold  pl-2" >Précédent</span>
                        </a>
                      </div>
                    </div> 

                    <div class="col-6 text-right">

                     
                      <div style="cursor: pointer;" v-if="this.nextBlog">
                        <a :href="'/actualites/' + encodeURIComponent(nextBlog.seoName)">
                          <span class="font-size-18 text-dark  font-weight-bold  pr-2" >Suivant</span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-1">
                          <path d="M5 12H19" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13 18L19 12" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13 6L19 12" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </a>
                      </div>
                    

                  </div> 
                  </div>
                </div>


                <div class="row mt-3 d-none d-xxxl-flex">
                  <div class="col-12  mt-4" style="display: contents;">
                    <div class="col-4 text-left" v-if="this.previousBlog">
                      <a :href="'/actualites/' + encodeURIComponent(previousBlog.seoName)">
                        <div class="row" style="cursor: pointer;">
                          <div class="col-12 col-xl-3 text-left " >
                            <img v-bind:src="'/api/image/get/' + previousBlog.image" alt height="66" width="115"   style="cursor: pointer;" />
                          </div>
                          <div class="col-12 col-xl-9  text-left font-size-20 font-weight-bold" >
                            <span class="text-dark" :title="previousBlog.name" style="display: -webkit-box; overflow: hidden;max-width: 255px;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"> 
                              {{previousBlog.name}}</span>
                            </div>

                        </div>
                      </a>
                    </div> 
                    <div v-else class="col-4" />

                    <div class="col-4 "/>


                    <div class="col-4 text-right" v-if="this.nextBlog">
                      <a :href="'/actualites/' + encodeURIComponent(nextBlog.seoName)">
                        <div class="row" style="cursor: pointer;" >
                          <div class="col-3" />
                          <div class="col-6 text-right font-size-20 font-weight-bold" >
                            <span :title="nextBlog.name" class="text-dark" style="display: -webkit-box; overflow: hidden;max-width: 250px;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"> 
                              {{nextBlog.name}}</span>
                          </div>
                          <div class="col-3 text-right w-70" >
                            <img v-bind:src="'/api/image/get/' + nextBlog.image" alt height="66" width="115"   style="cursor: pointer;" />
                          </div>

                        </div>
                      </a>

                  </div> 
                  </div>
                </div>

                <div  style="border-top: 1px solid rgba(234, 234, 234, 1) ;margin-top:70px ; padding-top: 50px;"/>       
                <div class="col-1"/>

            </div>
        </div>
    </div>
    
  </Layout>
</template>
<style>

.ql-size-large {
  font-size: 1.25rem; /* 20px */
}

.ql-size-huge {
  font-size: 1.5rem; /* 24px */
}


.ql-align {
  text-align: left;
}

.ql-align-left {
  text-align: left;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-justify {
  text-align: justify;
}


 </style>
<style scoped>

@media (min-width: 1750px) {
  .d-xxxl-flex {
    display: flex !important;
  }
}

</style>



